import { FooterLink } from '../FooterLinkTypes';

type AppLink = FooterLink & {
    href: string;
};

const appLink: AppLink = {
    trackingLabel: 'app store link',
    href: 'https://itunes.apple.com/us/app/1stdibs/id938157117?mt=8',
    dataTn: 'footer-download',
};

export default appLink;
